import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { color } from 'ui/variables'
import './typography.css'

export const Display1 = createTypeComponent('Display1', color.grey['500'], [
  color.grey['500'],
  color.white
])

export const Display2 = createTypeComponent('Display2', color.grey['500'], [
  color.white,
  color.grey['500']
])

export const Display3 = createTypeComponent('Display3', color.grey['500'], [
  color.white,
  color.grey['500']
])

export const Display4 = createTypeComponent('Display4', color.grey['500'], [
  color.white,
  color.grey['500'],
  color.pink['500']
])

export const Body1 = createTypeComponent('Body1', color.grey['500'], [
  color.white,
  color.grey['500'],
  color.grey['500'],
  color.grey['300'],
  color.green['50'],
  color.blue['50'],
  color.pink['400'],
  color.pink['500'],
  color.green['500']
])

export const Body2 = createTypeComponent('Body2', color.grey['500'], [
  color.white,
  color.grey['500'],
  color.grey['500'],
  color.grey['300'],
  color.green['50'],
  color.green['500'],
  color.blue['50'],
  color.pink['400'],
  color.pink['500']
])

function createTypeComponent(typeName, defaultColor, allowedColors) {
  class typography extends Component {
    render() {
      const { children, ...style } = this.props
      return (
        <span className={typeName} style={style}>
          {children}
        </span>
      )
    }
  }

  typography.defaultProps = {
    color: defaultColor
  }

  typography.propTypes = {
    color: PropTypes.string,
    display: PropTypes.string,
    textAlign: PropTypes.string,
    fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    children: PropTypes.node.isRequired
  }

  typography.displayName = typeName

  return typography
}



// WEBPACK FOOTER //
// ./ui/typography.js